import CancellableHelper from "@/requests/CancellableHelper";
import { ServicePackage } from "@/models/api/administration/servicesAndAttributes/ServicePackage";
import { ServicePackageItem } from "@/models/api/administration/servicesAndAttributes/ServicePackageItem";
import { ServicePackageRootItem } from "@/models/api/administration/servicesAndAttributes/ServicePackageRootItem";
import { ServicePackageSubItem } from "@/models/api/administration/servicesAndAttributes/ServicePackageSubItem";

//#region Routes
export const URL_GET_SERVICE_PACKAGES = "/ServicePackage";
export const URL_GET_VALIDATE_SERVICE_PACKAGE = "/ServicePackage/${ServicePackageId}/Validate";
export const URL_GET_SERVICE_PACKAGE_ITEMS = "/ServicePackage/${ServicePackageId}/Items";
export const URL_POST_ADD_SERVICE_PACKAGE = "/ServicePackage/Add";
export const URL_POST_EDIT_SERVICE_PACKAGE = "/ServicePackage/${ServicePackageId}/Edit";
export const URL_POST_REMOVE_SERVICE_PACKAGE = "/ServicePackage/${ServicePackageId}/Remove";
export const URL_POST_ADD_SERVICE_PACKAGE_ROOT_ITEM = "/ServicePackage/${ServicePackageId}/Item/AddRoot";
export const URL_POST_ADD_SERVICE_PACKAGE_SUB_ITEM = "/ServicePackage/${ServicePackageId}/Item/AddSub";
export const URL_POST_SLIDE_DOWN_SERVICE_PACKAGE_ITEM =
  "/ServicePackage/${ServicePackageId}/Item/${ServicePackageItemId}/SlideDown";
export const URL_POST_SLIDE_UP_SERVICE_PACKAGE_ITEM =
  "/ServicePackage/${ServicePackageId}/Item/${ServicePackageItemId}/SlideUp";
export const URL_POST_EDIT_SERVICE_PACKAGE_ROOT_ITEM =
  "/ServicePackage/${ServicePackageId}/Item/${ServicePackageItemId}/EditRoot";
export const URL_POST_EDIT_SERVICE_PACKAGE_SUB_ITEM =
  "/ServicePackage/${ServicePackageId}/Item/${ServicePackageItemId}/EditSub";
export const URL_POST_REMOVE_SERVICE_PACKAGE_ITEM =
  "/ServicePackage/${ServicePackageId}/Item/${ServicePackageItemId}/Remove";
//#endregion

const _getServicePackages = new CancellableHelper<Array<ServicePackage>>(URL_GET_SERVICE_PACKAGES, ServicePackage);
export const getServicePackages = async (): Promise<Array<ServicePackage>> => {
  return await _getServicePackages.get();
};

const _addServicePackage = new CancellableHelper<string>(URL_POST_ADD_SERVICE_PACKAGE, "string");
export const addServicePackage = async (packageName: string): Promise<string> => {
  return await _addServicePackage.post({}, { Name: packageName });
};

const _editServicePackage = new CancellableHelper<null>(URL_POST_EDIT_SERVICE_PACKAGE, null, true);
export const editServicePackage = async (packageName: string, servicePackageId: string): Promise<null> => {
  return await _editServicePackage.post({ ServicePackageId: servicePackageId }, { Name: packageName });
};

const _validateServicePackage = new CancellableHelper<null>(URL_GET_VALIDATE_SERVICE_PACKAGE, null, true);
export const validateServicePackage = async (servicePackageId: string): Promise<null> => {
  return await _validateServicePackage.get({ ServicePackageId: servicePackageId });
};

const _removeServicePackage = new CancellableHelper<null>(URL_POST_REMOVE_SERVICE_PACKAGE, null, true);
export const removeServicePackage = async (servicePackageId: string): Promise<null> => {
  return await _removeServicePackage.post({ ServicePackageId: servicePackageId }, null);
};

const _getServicePackageItems = new CancellableHelper<Array<ServicePackageItem>>(
  URL_GET_SERVICE_PACKAGE_ITEMS,
  ServicePackageItem
);
export const getServicePackageItems = async (servicePackageId: string): Promise<Array<ServicePackageItem>> => {
  return await _getServicePackageItems.get({ ServicePackageId: servicePackageId });
};

const _addServicePackageRootItem = new CancellableHelper<null>(URL_POST_ADD_SERVICE_PACKAGE_ROOT_ITEM, null, true);
export const addServicePackageRootItem = async (
  servicePackageId: string,
  servicePackageRootItem: ServicePackageRootItem
): Promise<null> => {
  return await _addServicePackageRootItem.post({ ServicePackageId: servicePackageId }, servicePackageRootItem);
};

const _editServicePackageRootItem = new CancellableHelper<null>(URL_POST_EDIT_SERVICE_PACKAGE_ROOT_ITEM, null, true);
export const editServicePackageRootItem = async (
  servicePackageId: string,
  servicePackageRootItem: ServicePackageRootItem,
  servicePackageItemId: string
): Promise<null> => {
  return await _editServicePackageRootItem.post(
    { ServicePackageId: servicePackageId, ServicePackageItemId: servicePackageItemId },
    servicePackageRootItem
  );
};

const _slideDownServicePackageItem = new CancellableHelper<null>(URL_POST_SLIDE_DOWN_SERVICE_PACKAGE_ITEM, null, true);
export const slideDownServicePackageItem = async (
  servicePackageId: string,
  servicePackageItemId: string
): Promise<null> => {
  return await _slideDownServicePackageItem.post(
    { ServicePackageId: servicePackageId, ServicePackageItemId: servicePackageItemId },
    null
  );
};

const _slideUpServicePackageItem = new CancellableHelper<null>(URL_POST_SLIDE_UP_SERVICE_PACKAGE_ITEM, null, true);
export const slideUpServicePackageItem = async (
  servicePackageId: string,
  servicePackageItemId: string
): Promise<null> => {
  return await _slideUpServicePackageItem.post(
    { ServicePackageId: servicePackageId, ServicePackageItemId: servicePackageItemId },
    null
  );
};

const _addServicePackageSubItem = new CancellableHelper<null>(URL_POST_ADD_SERVICE_PACKAGE_SUB_ITEM, null, true);
export const addServicePackageSubItem = async (
  servicePackageId: string,
  servicePackageSubItem: ServicePackageSubItem
): Promise<null> => {
  return await _addServicePackageSubItem.post({ ServicePackageId: servicePackageId }, servicePackageSubItem);
};

const _editServicePackageSubItem = new CancellableHelper<null>(URL_POST_EDIT_SERVICE_PACKAGE_SUB_ITEM, null, true);
export const editServicePackageSubItem = async (
  servicePackageId: string,
  servicePackageSubItem: ServicePackageSubItem,
  servicePackageItemId: string
): Promise<null> => {
  return await _editServicePackageSubItem.post(
    { ServicePackageId: servicePackageId, ServicePackageItemId: servicePackageItemId },
    servicePackageSubItem
  );
};

const _removeServicePackageItem = new CancellableHelper<null>(URL_POST_REMOVE_SERVICE_PACKAGE_ITEM, null, true);
export const removeServicePackageItem = async (
  servicePackageId: string,
  servicePackageItemId: string
): Promise<null> => {
  return await _removeServicePackageItem.post(
    { ServicePackageId: servicePackageId, ServicePackageItemId: servicePackageItemId },
    null
  );
};
